/** @jsxImportSource theme-ui */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Flex, Button, Text } from '@infotrack/zenith-ui';
import {
  headerContainerStyles,
  leftSectionStyles,
  rightSectionStyles,
} from './importPageHeader.styles';

export const AddUpdatePageHeader: React.FC = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/topfive');
  };

  return (
    <Flex role="banner" sx={headerContainerStyles}>
      <Flex sx={leftSectionStyles}>
        {/* Logo */}
        <Text variant="hero" color="primary/600">
          iTop5
        </Text>
      </Flex>

      <Flex sx={rightSectionStyles}>
        <Button
          iconProps={{ name: 'arrow_back' }}
          variant="secondary"
          size="small"
          onClick={handleBackClick}
          aria-label="Back to TOP 5 list"
        >
          Back
        </Button>
      </Flex>
    </Flex>
  );
};
